<template>
	<section class="columns is-multiline is-mobile">
		<Title />
		<div v-if="visible" class="page__actions column">
			<slot></slot>
		</div>
		<Weather :bordered="bordered" />
		<button id="button-theme" class="page__button page__button--mode" @click="mode()">
			<b-icon :icon="isDark ? 'weather-night' : 'white-balance-sunny'"></b-icon>
		</button>
		<Notifications />
	</section>
</template>

<script>
import Title from '@/components/Title'
import Weather from '@/components/Weather'
import Notifications from '@/components/Notifications'
import { mapGetters, mapMutations } from 'vuex'
import Api from '@/services/api'
import { storageGet, storageSet } from '@/services/storage'

export default {
	name: 'Header',
	components: {
		Title,
		Weather,
		Notifications
	},
	props: {
		bordered: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			visible: true
		}
	},
	computed: {
		...mapGetters('user', [
			'isDark']
		),
		name() {
			return this.$route.name
		}
	},
	mounted() {
		const slot = this.$slots.default
		this.visible = slot && slot.length > 0 ? true : false
	},
	methods: {
		...mapMutations('user', [
			'setTheme'
		]),
		mode() {
			let newTheme = this.isDark ? 'light' : 'dark'

			this.setTheme(newTheme)
			let user = JSON.parse(storageGet('@stup:user'))
			user.theme = newTheme
			storageSet('@stup:user', JSON.stringify(user))

			Api.post('users/theme', { theme: newTheme })
		}
	}
}
</script>
